import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class MerchantAccountService extends Service {
    constructor() {
        super();
        this.baseURL = 'crm/merchant/account';
    }


    async updateContact(accountId, contact) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + accountId + "/contact", {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(contact)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async getCompanyInfo(companyNo) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/company/" + companyNo, {
            crossDomain: true,
            method: 'get',
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }




}